"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolDef = void 0;
exports.handle = handle;
const fs = __importStar(require("fs-extra"));
const dist_1 = require("../../../fs/dist");
const renameDocFile_1 = require("../../../app/dist/renameDocFile");
exports.toolDef = {
    name: 'loom_rename_reference_file',
    description: "Rename a REFERENCE doc's filename slug ({slug}.md). References are the one doc type whose filename is a human slug, so they're the one type where a filename rename is meaningful — idea/design/plan/chat filenames are machine-owned (use loom_retitle to change a title). Updates the filename and the slug frontmatter in lockstep; the ULID id and backlinks are untouched. Refuses non-reference docs. (Renamed from loom_rename_doc_file — it only acts on references.) Use this tool — do not rename doc files directly.",
    inputSchema: {
        type: 'object',
        properties: {
            doc_ulid: { type: 'string', description: 'Reference doc ULID (a reference slug is also resolved).' },
            new_slug: { type: 'string', description: 'New filename slug (kebab-cased; no .md).' },
        },
        required: ['doc_ulid', 'new_slug'],
    },
};
async function handle(root, args) {
    const result = await (0, renameDocFile_1.renameDocFile)({ id: args['doc_ulid'], newSlug: args['new_slug'] }, { getActiveLoomRoot: () => (0, dist_1.getActiveLoomRoot)(root), fs, loadDoc: dist_1.loadDoc, saveDoc: dist_1.saveDoc, resolveDocIdOrThrow: dist_1.resolveDocIdOrThrow });
    return { content: [{ type: 'text', text: JSON.stringify(result) }] };
}
